// @flow

import React from "react";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { Tbody } from "@chakra-ui/react";

import type { DeletedChecklistField } from "src/types";

import SortableItem from "./SortableItem";

type Props = {
  items: DeletedChecklistField[],
  itemIds: string[],
  updateField: Function,
  restoreField: Function,
};

const SortableList = ({ items, itemIds, updateField, restoreField }: Props) => {
  return (
    <SortableContext items={itemIds} strategy={verticalListSortingStrategy}>
      <Tbody>
        {items.map((value, index) => (
          <SortableItem
            key={itemIds[index]}
            id={itemIds[index]}
            index={index}
            position={index}
            value={value}
            updateField={updateField}
            restoreField={restoreField}
          />
        ))}
      </Tbody>
    </SortableContext>
  );
};

export default SortableList;
